import React from 'react'

const ModelCore = ({models}) => {
  return (
    <div>
          <div className='row mt-2'>
            {models.map((val,i)=>(
              <div key={i} className='col-lg-4   ' >
                <div className=' p-3 bg-light shadow h-100' style={{width:''}}>
                  <h3 className='text-center bg-gray p-2 mb-3 text-white h3-heading '>{val.title}</h3>
                  <ul className='list-dark ms-2 fs-6 h3-para'>
                    <li className='mt-1'>{val.desc}</li>
                    <li className='mt-1'>{val.desc2}</li>
                    <li className='mt-1'>{val.desc3}</li>
                    <li className='mt-1'>{val.desc4}</li>
                    <li className='mt-1'>{val.desc5}</li>
                  </ul>
                </div>
              </div>
            ))}
          </div>

    </div>
  )
}

export default ModelCore